import React from 'react';
import './Button.css';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium', 
  fullWidth = false,
  disabled = false
}) => {
  const classNames = [
    'game-button',
    `game-button--${variant}`,
    `game-button--${size}`,
    fullWidth ? 'game-button--full-width' : ''
  ].filter(Boolean).join(' ');

  return (
    <button 
      className={classNames} 
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
